import { convertToCustomer } from 'actions/customer/CustomerConverter';
import { getCustomerByTokenThunk } from 'actions/customer/CustomerActions';
import { authenticateOnlineBookingCustomerThunk } from 'actions/onlineBooking/actions/OnlineBookingCustomerActions';
import { ApiPublicClient } from 'api/ApiClient';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { markArrivedFromPortal } from 'utils/petParentPortal';

const redeemUrl = 'handoff/redeem';

interface RedeemHandoffResponseDto {
    success: boolean;
    token: string;
    customer_id: number;
    marketplace_id: number;
}

/**
 * Exchanges the one-time code the Pet Parent Portal handed over for a session.
 * Any failure resolves to false so the caller can fall back to the public flow (the
 * Add-Ons mode shows its own "session expired" screen instead):
 * expired, already redeemed and unknown codes are answered identically on
 * purpose, and retrying is pointless because the code is single-use.
 */
export const redeemHandoffCodeThunk = (
    handoffCode: string,
    marketplaceId: number,
    { startWizard = true }: { startWizard?: boolean } = {}
): ThunkAction<Promise<boolean>, RootState, null, RootAction> => {
    return async dispatch => {
        try {
            const { data } = await ApiPublicClient.post<RedeemHandoffResponseDto>(redeemUrl, {
                handoff_code: handoffCode,
                marketplace_id: marketplaceId
            });

            const customerDto = await dispatch(getCustomerByTokenThunk(data.token, marketplaceId));

            markArrivedFromPortal();
            dispatch(
                authenticateOnlineBookingCustomerThunk(data.token, convertToCustomer(customerDto), {
                    startWizard
                })
            );

            return true;
        } catch {
            return false;
        }
    };
};
